import React from 'react'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit'
import BtnWhite from '../../../../Shared/Buttons/BtnWhite';
import { connect } from 'react-redux';
import { goToPage } from '../../DisconnectServiceSlice'
import { Container, Row, Col } from 'reactstrap';
import { isBrowser } from "react-device-detect";
import './PopUpAction'

export const PopUpContent = ({closePopUp, redirectTo}) => {

    function render() {
        if(isBrowser) {
            return (
                <div className="pop-up-container-root">
                    <h4 className="header">רגע לפני שסוגרים את האורות...</h4>
                    <div className="txt-block">הניתוק יהיה סופי ולא תהיה אפשרות לשחזר את תנאי החבילה הנוכחית</div>
                    <div className="btns">
                        <Container>
                            <Row style={{flexWrap: 'inherit'}}>
                                <Col>
                                    <BtnSubmit onclick={() => redirectTo()} text="אני רוצה להתנתק"/>
                                </Col>
                                <Col>
                                    <BtnWhite  onclick={() => closePopUp()} text="אני רוצה לחשוב על זה"/>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="pop-up-container-root">
                    <h4 className="header">רגע לפני שסוגרים את האורות...</h4>
                    <div className="txt-block">ההניתוק יהיה סופי ולא תהיה אפשרות לשחזר את תנאי החבילה הנוכחית</div>
                    <div className="btns">
                        <Container>
                            <Row style={{flexWrap: 'inherit'}}>
                                <Col>
                                    <BtnSubmit onclick={() => redirectTo()} text="אני רוצה להתנתק"/>
                                </Col>
                                <Col className="pr-0">
                                    {/* <BtnWhite  onclick={() => closePopUp()} text="לא לנתק"/> */}
                                    <BtnWhite onclick={() => closePopUp()} text="אני רוצה לחשוב על זה"/>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            )
        }
    }
    
    return (
        render()
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams
});
  
const mapDispatchToProps = {
    goToPage,
};
  
export default connect(mapStateToProps, mapDispatchToProps)(PopUpContent);